export const maskNumber = (input) => {
  if (!input || input.length < 5) return input;

  const start = input.slice(0, 3);
  const end = input.slice(-2);
  const masked = "x".repeat(input.length - 5);

  return `${start}${masked}${end}`;
};

/**
This maskNumberAdvanced function created by anoop date 7july/05/2025
 */
  export const maskNumberAdvanced = (input = "") => {
    if (input.length <= 3) return input;
    const last3 = input.slice(-3);
    const startIndexOfMasked = Math.max(0, input.length - 8);
    const visiblePrefix = input.slice(0, startIndexOfMasked);
    const maskedPartLength = Math.min(5, input.length - 3 - visiblePrefix.length);
    const maskedPart = "x".repeat(maskedPartLength);

    return `${visiblePrefix}${maskedPart}${last3}`;
  };

export const compactTextField = {
  "& .MuiInputBase-root": {
    height: 40,
    fontSize: "14px",
  },
  "& .MuiInputBase-input": {
    padding: "8px 12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
  },
};

export const iconButtonStyle = {
  color: '#1976d2',
  border: '1px solid #1976d2',
  borderRadius: '8px',
  padding: '2px',
};